module.exports = __webpack_public_path__ + "static/media/AvatarMale.4b8d7e36.svg";